import { AxiosResponse } from "axios";
import { Response } from "../../types/api";
import { BankRequisites } from "../../types/bankRequisites";
import protectedInstance from "../instances/protected";

async function getBankRequisites(companyId: number) {
  return protectedInstance
    .get(`/company/${companyId}/bank-requisites`)
    .then((res: AxiosResponse<Response<BankRequisites[]>>) => res.data);
}

async function getBankRequisite(companyId: number, requisiteId: number) {
  return protectedInstance
    .get(`/company/${companyId}/bank-requisite/${requisiteId}`)
    .then((res: AxiosResponse<Response<BankRequisites>>) => res.data);
}

async function createBankRequisite(companyId: number, data: Omit<BankRequisites, 'id' | 'companyId' | 'createdAt' | 'updatedAt'>) {
  return protectedInstance
    .post(`/company/${companyId}/bank-requisite`, data)
    .then((res: AxiosResponse<Response<BankRequisites>>) => res.data);
}

async function updateBankRequisite(companyId: number, requisiteId: number, data: Omit<BankRequisites, 'id' | 'companyId' | 'createdAt' | 'updatedAt'>) {
  return protectedInstance
    .put(`/company/${companyId}/bank-requisite/${requisiteId}`, data)
    .then((res: AxiosResponse<Response<BankRequisites>>) => res.data);
}

async function deleteBankRequisite(companyId: number, requisiteId: number) {
  return protectedInstance
    .delete(`/company/${companyId}/bank-requisite/${requisiteId}`)
    .then((res: AxiosResponse<Response<null>>) => res.data);
}

export const bankRequisitesService = {
  getBankRequisites,
  getBankRequisite,
  createBankRequisite,
  updateBankRequisite,
  deleteBankRequisite
};